<div class="d-flex flex-column">
  <div *ngFor="let f of assignees">
    <div *ngIf="f.result == 'Forwarded'">
      <div class="d-flex align-items-center">
        <kendo-icon name="redo" themeColor="primary"></kendo-icon>
        <span>{{'step_details_label_forwarded' | i18n}}:</span>
        <circ-person-from-login [fontSize]="14" [login]="getLogin(f)" [showLogin]="false" [showImage]="false">
        </circ-person-from-login>
      </div>
      <div class="d-flex align-items-center" *ngIf="f.comment">
        <kendo-icon name="paste-plain-text" themeColor="primary"></kendo-icon>
        <span> {{f.comment}} </span>
      </div>
    </div>
  </div>
</div>
